import React, { useState, useEffect } from 'react';
import { Card, Button, Form, Row, Col } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { GetMachine_lastStatus } from '../../components/Functions/GetMachine';
import { PostMachine } from '../../components/Functions/PostMachine';
import { toast } from 'react-toastify';

function MachineForm({ mode = 'create' }) {
    const navigate = useNavigate();
    const params = useParams();
    const ucParam = params.uc;

    const [formData, setFormData] = useState(null);
    const [cpOptions, setCpOptions] = useState([]);

    useEffect(() => {
        const loadData = async () => {
            try {
                const data = await GetMachine_lastStatus();
                const macchine = data.STATI;

                const existingCPs = macchine
                    .map(m => parseInt(m.CP))
                    .filter(cp => !isNaN(cp));
                const maxCP = Math.max(...existingCPs);
                const allCPs = Array.from({ length: maxCP }, (_, i) => i + 1);
                let missingCPs = allCPs.filter(n => !existingCPs.includes(n));
                let availableCPs = [...missingCPs, maxCP + 1];

                if (mode === 'edit') {
                    const macchina = macchine.find(m => m.UC === ucParam);
                    if (macchina) {
                        const currentCP = parseInt(macchina.CP);
                        if (!availableCPs.includes(currentCP)) {
                            availableCPs.push(currentCP);
                        }
                        availableCPs.sort((a, b) => a - b);

                        setFormData({
                            IDM: 1,
                            IDS: macchina.IDS || 'Malo',
                            IDR: macchina.IDR,
                            CP: macchina.CP && macchina.CP !== "null" ? macchina.CP : '',
                            IDO: 'system',
                            TY: macchina.TY,
                            UC: macchina.UC,
                            MOD: macchina.MOD,
                            ST: 0,
                            ER: '0',
                            FM: macchina.FM,
                            TIMESTAMP: new Date().toISOString().replace('T', ' ').substring(0, 19),
                            NOTA: 'INSTALLAZIONE MACCHINARIO',
                            CRC: Math.floor(Math.random() * 10000),
                        });
                    }
                } else {
                    availableCPs.sort((a, b) => a - b);
                    setFormData({
                        IDM: 1,
                        IDS: 'Malo',
                        IDR: 'TaglioPelle',
                        CP: '',
                        IDO: 'system',
                        TY: '',
                        UC: '',
                        MOD: '',
                        ST: 0,
                        ER: '0',
                        FM: '',
                        TIMESTAMP: new Date().toISOString().replace('T', ' ').substring(0, 19),
                        NOTA: 'INSTALLAZIONE MACCHINARIO',
                        CRC: Math.floor(Math.random() * 10000),
                    });
                }

                setCpOptions(availableCPs);
            } catch (error) {
                console.error('Errore caricamento dati macchina:', error);
            }
        };

        loadData();
    }, [mode, ucParam]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const toUppercase = ['UC', 'MOD', 'FM'];
        setFormData(prev => ({
            ...prev,
            [name]: toUppercase.includes(name) ? value.toUpperCase() : value
        }));
    };

    const validateForm = () => {
        const requiredFields = ['UC', 'MOD', 'FM', 'TY', 'IDR', 'CP'];
        const fieldLabels = {
            UC: 'Matricola',
            MOD: 'Modello',
            FM: 'Marchio',
            TY: 'Tipologia',
            IDR: 'Reparto',
            CP: 'Postazione'
        };

        for (const field of requiredFields) {
            if (!formData[field] || formData[field].toString().trim() === '') {
                toast.error(`Il campo "${fieldLabels[field]}" è obbligatorio.`);
                return false;
            }
        }

        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        const finalCP = formData.CP === '' || formData.CP === null
            ? cpOptions.find(cp => cp === formData.CP) || formData.CP
            : formData.CP;

        const payload = {
            IDM: 1,
            IDS: formData.IDS,
            IDR: formData.IDR,
            CP: finalCP,
            IDO: 'system',
            TY: formData.TY,
            UC: formData.UC,
            MOD: formData.MOD,
            ST: 0,
            ER: '0',
            FM: formData.FM,
            TIMESTAMP: formData.TIMESTAMP,
            NOTA: 'INSTALLAZIONE MACCHINARIO',
            CRC: formData.CRC
        };

        try {
            await PostMachine(payload);
            navigate('/Machines');
        } catch (err) {}
    };

    const handleDismetti = async () => {
        if (!window.confirm("Sei sicuro di voler dismettere questa macchina?")) return;

        const dismissionePayload = {
            IDM: 1,
            IDS: formData.IDS,
            IDR: formData.IDR,
            CP: "null",
            IDO: "system",
            TY: formData.TY,
            UC: formData.UC,
            MOD: formData.MOD,
            ST: 0,
            ER: "0",
            FM: formData.FM,
            TIMESTAMP: new Date().toISOString().replace('T', ' ').substring(0, 19),
            NOTA: "MODIFICA MANUALE - DISMISSIONE MACCHINA",
            CRC: Math.floor(Math.random() * 10000)
        };

        try {
            await PostMachine(dismissionePayload);
            navigate('/Machines');
        } catch (err) {}
    };

    if (!formData) return <div>Loading...</div>;

    return (
        <Card className="cardModifiche">
            <Card.Header className="titleCard">
                {mode === 'edit' ? 'Modifica Macchina' : 'Nuova Macchina'}
            </Card.Header>
            <Card.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group>
                        <Form.Label>Reparto</Form.Label>
                        <Form.Select name="IDR" value={formData.IDR} onChange={handleChange} required>
                            <option value="TaglioPelle">TaglioPelle</option>
                            <option value="TaglioAusiliari">TaglioAusiliari</option>
                        </Form.Select>
                    </Form.Group>

                    {mode === 'create' && (
                        <>
                            <Form.Group>
                                <Form.Label>Tipologia macchinario</Form.Label>
                                <Form.Select name="TY" value={formData.TY} onChange={handleChange} required>
                                    <option value="">Seleziona tipo</option>
                                    <option value="A">Automatica</option>
                                    <option value="M">Manuale</option>
                                </Form.Select>
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>Matricola</Form.Label>
                                <Form.Control name="UC" value={formData.UC} onChange={handleChange} required />
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>Modello</Form.Label>
                                <Form.Control name="MOD" value={formData.MOD} onChange={handleChange} />
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>Marchio</Form.Label>
                                <Form.Control name="FM" value={formData.FM} onChange={handleChange} />
                            </Form.Group>
                        </>
                    )}

                    <Form.Group>
                        <Form.Label>Postazione</Form.Label>
                        <Form.Select name="CP" value={formData.CP} onChange={handleChange} required>
                            <option value="">Seleziona Codice Postazione</option>
                            {cpOptions.map(cp => (
                                <option key={cp} value={cp}>{cp}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Card className="mb-4 mt-3 p-3 shadow-sm" style={{ background: '#f8f9fa' }}>
                        <h5 className="mb-3">Informazioni Macchina</h5>
                        <Row>
                            <Col md={6} className="mb-2"><strong>Stabilimento:</strong> {formData.IDS}</Col>
                            <Col md={6} className="mb-2"><strong>Reparto:</strong> {formData.IDR}</Col>
                            <Col md={6} className="mb-2"><strong>Postazione:</strong> {formData.CP}</Col>
                            <Col md={6} className="mb-2"><strong>Tipologia:</strong> {formData.TY === 'A' ? 'Automatica' : formData.TY === 'M' ? 'Manuale' : ''}</Col>
                            <Col md={6} className="mb-2"><strong>Matricola:</strong> {formData.UC}</Col>
                            <Col md={6} className="mb-2"><strong>Modello:</strong> {formData.MOD}</Col>
                            <Col md={6} className="mb-2"><strong>Marchio:</strong> {formData.FM}</Col>
                        </Row>
                    </Card>

                    <div style={{ marginTop: '20px' }}>
                        <Button type="submit" className="confirmButton">
                            {mode === 'edit' ? 'Salva Modifiche' : 'Crea Macchina'}
                        </Button>{' '}
                        <Button variant="secondary" onClick={() => navigate('/Machines')}>
                            Annulla
                        </Button>
                        {mode === 'edit' && (
                            <Button variant="danger" onClick={handleDismetti} style={{ marginLeft: '10px' }}>
                                Dismetti Macchina
                            </Button>
                        )}
                    </div>
                </Form>
            </Card.Body>
        </Card>
    );
}

export default MachineForm;
